import { css } from 'emotion'
import { Colors, CardTitle, SliderLabel } from '../';

export const VideoTemplateStyle = (picture) => css({
  height: 'calc(100vh - 140px)',
  width: '100%',

  '@media (min-width: 1024px)': {
    height: 'calc(100vh - 160px)',
  },
  '.suggest-container': {
    flexGrow: 1,
    maxWidth: '100%',
    flexBasis: '100%',
    overflow: 'visible',
    '@media (min-width: 1024px)': {
      maxWidth: 'calc(3/4 * 100%)',
      flexBasis: 'calc(3/4 * 100%)',
    },
  },
  '.card': {
    '@media (min-width: 1024px)': {
      maxWidth: `calc(1/${picture ? 2 : 3} * 100%)`,
      flexBasis: `calc(1/${picture ? 2 : 3} * 100%)`,
      padding: '1rem',
      minWidth: 260,
    },
    '@media (min-width: 1640px)': {
      minWidth: 280,
    },
    '&-info': {
      minHeight: 110,
    }
  },
  'h2.subtitle' : {
    maxWidth: '100%',
    flexBasis: '100%',
    '@media (min-width: 1024px)': {
      maxWidth: 'calc(1/4 * 100%)',
      flexBasis: 'calc(1/4 * 100%)',
    },
  },
  '.videos-template':{
    '&-inner': {
      position: 'relative',
      zIndex: 2,
      padding: '1.5rem',
      height: '100%',
      overflow: 'auto',
      '@media (min-width: 1024px)': {
        padding: '8rem',
      },
    }
  },
  'h2' : {
    textTransform: 'uppercase',
  },
  '.template-scroll' : {
    height: '100%',
  },
  '.template-right' : {
    height: '100%',
  }
})

export const VideoContainerStyle = (picture, isFull) => css({
  maxWidth: 'calc(1/2 * 100vw - 4rem)',
  flexBasis: 'calc(1/2 * 100vw - 4rem)',
  margin: '1rem',
  '@media (min-width: 1024px)': {
    maxWidth: 'calc(1/4 * 100vw - 8rem)',
    flexBasis: 'calc(1/4 * 100vw - 8rem)',
  },
  '.video': {
    position: 'relative',
    width: '100%',
    height: 110,
    background: `black url(${picture}) no-repeat center`,
    backgroundSize: 'cover',
    cursor: 'pointer',
    '@media (min-width: 1024px)': {
      height: 220,
    },
    '.btn': {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 50,
      height: 50,
      border: 0,
      padding: 0,
      margin: 0,
      zIndex: 2,
      background: Colors.red,
      transition: 'background 400ms ease',
      '&:hover': {
        background: 'black',
      },
      'svg': {
        fill: 'white',
        transform: 'rotate(90deg)',
      }
    },
    '&-label': {
      display: 'block',
      color: 'white',
      ...SliderLabel,
      fontWeight: 'bold',
      margin: '0.5rem 0',
    },
    '&-container-full': {
      height: '100%',
      overflow: 'hidden',
      width: '100%',
      display: isFull ? 'block' : 'none',
      
      '.video-close': {
        position: 'absolute',
        width: 50,
        height: 50,
        top: '2rem',
        right: '2rem',
        border: '2px solid white',
        zIndex: 10,
        background: 'none',
        borderRadius: 9999,
        cursor: 'pointer',
        transition: 'all 400ms ease',
        margin: 0,
        '@media (min-width: 1024px)': {
          top: '4rem',
          right: '4rem',
        },
        'span': {
          position: 'absolute',
          top: '50%',
          left: '50%',
          height: '50%',
          width: '2px',
          background: 'white',
          transform: 'translate(-50%, -50%) rotate(-45deg)',
          transition: 'all 400ms ease',
          '&:last-child': {
            transform: 'translate(-50%, -50%) rotate(45deg)',
          }
        },
        '&:hover': {
          background: 'white',
          'span': {
            background: 'black',
          }
        }
      },
      '.video-wrapper': {
        display: 'block',
        height: '100%',
        left: 0,
        overflow: 'hidden',
        position: 'absolute',
        top: '50%',
        width: '100%',
        WebkitTransform: 'translateY(-50%)',
        transform: 'translateY(-50%)'
      },
      '.video-iframe': {
        left: 0,
        overflow: 'hidden',
        // paddingBottom: '56.25%',
        position: 'absolute',
        top: '50%',
        width: '100%',
        height: '100%',
        WebkitTransformOrigin: '50% 0',
        transformOrigin: '50% 0',
        WebkitTransform: 'translateY(-50%)',
        transform: 'translateY(-50%)',
        display: 'block',
        zIndex: 5,
        background: 'black',
        'iframe': {
          display: 'block',
          height: '100%',
          width: '100%',
        }
      },
    }
  }
})

export const FullVideoContainerStyle = (picture, isFull, pos = 'center') => css({
  height: '100%',
  overflow: 'hidden',
  '.video': {
    position: 'relative',
    width: '100%',
    height: '100%',
    background: isFull ? 'black' : `black url(${picture}) no-repeat ${pos} center`,
    backgroundSize: 'cover',
    cursor: 'pointer',
    '@media (min-width: 1024px)': {
      height: '100%',
    },
    '.btn': {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 50,
      height: 50,
      border: 0,
      padding: 0,
      margin: 0,
      zIndex: 2,
      background: Colors.red,
      transition: 'background 400ms ease',
      cursor: 'pointer',
      '&:hover': {
        background: 'black',
      },
      'svg': {
        fill: 'white',
        transform: 'rotate(90deg)',
      }
    },
    '&-label': {
      display: 'block',
      color: 'white',
      ...SliderLabel,
      fontWeight: 'bold',
      margin: '0.5rem 0',
    },
    '&-container-full': {
      height: '100%',
      overflow: 'hidden',
      width: '100%',
      display: isFull ? 'block' : 'none',
      
      '.video-close': {
        position: 'absolute',
        width: 50,
        height: 50,
        top: '2rem',
        right: '2rem',
        border: '2px solid white',
        zIndex: 10,
        background: 'none',
        borderRadius: 9999,
        cursor: 'pointer',
        transition: 'all 400ms ease',
        margin: 0,
        '@media (min-width: 1024px)': {
          top: '4rem',
          right: '4rem',
        },
        'span': {
          position: 'absolute',
          top: '50%',
          left: '50%',
          height: '50%',
          width: '2px',
          background: 'white',
          transform: 'translate(-50%, -50%) rotate(-45deg)',
          transition: 'all 400ms ease',
          '&:last-child': {
            transform: 'translate(-50%, -50%) rotate(45deg)',
          }
        },
        '&:hover': {
          background: 'white',
          'span': {
            background: 'black',
          }
        }
      },
      '.video-wrapper': {
        display: 'block',
        height: '100%',
        left: 0,
        overflow: 'hidden',
        position: 'absolute',
        top: '50%',
        width: '100%',
        WebkitTransform: 'translateY(-50%)',
        transform: 'translateY(-50%)'
      },
      '.video-iframe': {
        left: 0,
        overflow: 'hidden',
        // paddingBottom: '56.25%',
        position: 'absolute',
        top: '50%',
        width: '100%',
        height: '100%',
        WebkitTransformOrigin: '50% 0',
        transformOrigin: '50% 0',
        WebkitTransform: 'translateY(-50%)',
        transform: 'translateY(-50%)',
        display: 'block',
        zIndex: 5,
        'iframe': {
          display: 'block',
          height: '100%',
          width: '100%',
        },
      },
    }
  }
})

export const VideoCardStyle = (isFull) => css({
  '.video-label': {
    ...CardTitle,
    margin: '0.5rem 0',
    color: 'black',
  },
  '.card-inner': {
    display: 'flex',
    flexDirection: 'column',
    cursor: 'pointer',
    width: '100%',
  },
  '.card-info': {
    flexGrow: 1,
  },
  '.card-link': {
    display: 'block',
    padding: '1rem 1.5rem',
  },
  '.video-container-full': {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: 'black',
    zIndex: 4,
    paddingTop: 80,
    paddingBottom: 80,
    display: isFull ? 'block' : 'none',
    '.video-close': {
      position: 'absolute',
      width: 50,
      height: 50,
      top: '2rem',
      right: '2rem',
      border: '2px solid white',
      zIndex: 10,
      background: 'none',
      borderRadius: 9999,
      cursor: 'pointer',
      transition: 'all 400ms ease',
      '@media (min-width: 1024px)': {
        top: '4rem',
        right: '4rem',
      },
      'span': {
        position: 'absolute',
        top: '50%',
        left: '50%',
        height: '50%',
        width: '2px',
        background: 'white',
        transform: 'translate(-50%, -50%) rotate(-45deg)',
        transition: 'all 400ms ease',
        '&:last-child': {
          transform: 'translate(-50%, -50%) rotate(45deg)',
        }
      },
      '&:hover': {
        background: 'white',
        'span': {
          background: 'black',
        }
      }
    },
    '.video-iframe': {
      position: 'absolute',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      fontSize: 0,
      'iframe': {
        width: '100vw',
        height: 'calc(100vh - 140px)',
        '@media (min-width: 1024px)': {
          height: 'calc(100vh - 160px)',
        }
      }
    },
  }
})

export const VideoStyle = (picture, isFull) => css({
  position: 'relative',
  width: '100%',
  background: `black url(${picture}) no-repeat center`,
  backgroundSize: 'cover',
  cursor: 'pointer',
  paddingTop: '45%',
  '.btn': {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    border: 0,
    padding: 0,
    margin: 0,
    zIndex: 2,
    color: 'white',
    fontSize: '1rem',
    textTransform: 'uppercase',
    letterSpacing: '2px',
    height: 50,
    lineHeight: '50px',
    padding: '0 2rem',
    cursor: 'pointer',
    background: Colors.red,
    transition: 'background 400ms ease',
    '&:hover': {
      background: 'black',
    },
    'svg': {
      fill: 'white',
      transform: 'rotate(90deg)',
      verticalAlign: 'middle',
      margin: '0 5px',
    }
  },
  '.video-container-full': {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: 'black',
    zIndex: 4,
    paddingTop: 80,
    paddingBottom: 80,
    display: isFull ? 'block' : 'none',
    '.video-close': {
      position: 'absolute',
      width: 50,
      height: 50,
      top: '2rem',
      right: '2rem',
      border: '2px solid white',
      zIndex: 10,
      background: 'none',
      borderRadius: 9999,
      cursor: 'pointer',
      transition: 'all 400ms ease',
      '@media (min-width: 1024px)': {
        top: '4rem',
        right: '4rem',
      },
      'span': {
        position: 'absolute',
        top: '50%',
        left: '50%',
        height: '50%',
        width: '2px',
        background: 'white',
        transform: 'translate(-50%, -50%) rotate(-45deg)',
        transition: 'all 400ms ease',
        '&:last-child': {
          transform: 'translate(-50%, -50%) rotate(45deg)',
        }
      },
      '&:hover': {
        background: 'white',
        'span': {
          background: 'black',
        }
      }
    },
    '.video-iframe': {
      position: 'relative',
      fontSize: 0,
      'iframe': {
        width: '100vw',
        height: 'calc(100vh - 140px)',
        '@media (min-width: 1024px)': {
          height: 'calc(100vh - 160px)',
        }
      }
    },
  }
})


// WEBPACK FOOTER //
// ./src/styles/components/video.js